import { ApiError } from '../lib/api'
import type { ReactNode } from 'react'
import { titleise } from '../lib/format'

export function Panel({ children, pad = false, className = '' }: {
  children: ReactNode; pad?: boolean; className?: string
}) {
  return <div className={`panel ${pad ? 'pad' : ''} ${className}`.trim()}>{children}</div>
}

export function Badge({ kind, value }: { kind: 'b' | 'seg' | 'inv'; value: string }) {
  return <span className={`badge ${kind}-${value}`}>{titleise(value)}</span>
}

export function Stat({ label, value, note, tone }: {
  label: string; value: ReactNode; note?: string; tone?: 'alert' | 'ok' | 'muted'
}) {
  return (
    <div className="stat">
      <div className="stat-label">{label}</div>
      <div className={`stat-value ${tone ? `v-${tone}` : ''}`}>{value}</div>
      {note && <div className="stat-note">{note}</div>}
    </div>
  )
}

export function Stats({ children }: { children: ReactNode }) {
  return <div className="stats">{children}</div>
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>
}

export function Loading() {
  return <div className="empty">Loading…</div>
}

export function ErrorBox({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : 'Something went wrong'
  // The status code is the difference between a problem someone can act on and one they
  // can only report. 403 means ask for access; 500 means tell Fernando.
  const status = error instanceof ApiError ? error.status : null
  return (
    <div className="alarm">
      {message}
      {status !== null && <span className="alarm-code"> ({status})</span>}
    </div>
  )
}

export function KV({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="kv">
      <span>{label}</span>
      <b>{children}</b>
    </div>
  )
}
